export default __webpack_public_path__ + "static/media/lpotlight-line.1be33062.svg";